import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

fetch('/assets/env.json')
  .then(res => res.json())
  .catch(err => { console.error('Failed to load env.json:', err); return {}; })
  .then(async env => {
    const { AuthService } = await import('./services/auth.service');
    if (env.graphClientId) {
      AuthService.GraphClientId = env.graphClientId;
    }
    const { AppModule } = await import('./app/app.module');
    return platformBrowserDynamic().bootstrapModule(AppModule);
  })
  .catch(err => console.error(err));
